// App.js (Entry point and routing)
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import DashboardScreen from './components/DashboardScreen';
import BookingScreen from './components/BookingScreen';
import DetailScreen from './components/DetailScreen';
import BookingConfirmScreen from './components/BookingConfirmScreen';

const App = () => {
  return (
    <Router>
      <div style={{ overflowX: 'hidden', width: '100%' }}>
        <Routes>
          {/* Redirect the base URL to /adwav */}
          <Route path="/" element={<Navigate to="/adwav" />} />
          {/* The /adwav route now renders the DashboardScreen */}
          <Route path="/adwav" element={<DashboardScreen />} />
          <Route path="/adwav/provider/:id" element={<DetailScreen />} />
          <Route path="/adwav/booking" element={<BookingScreen />} />
          <Route path="/adwav/confirm" element={<BookingConfirmScreen />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;
